export const invoices = () => {
  return {
    search_placeholder: 'Search',
    export_selected: 'Export Selected',
    export_invoice_selected: 'Download',
    download_selected: 'Download selected',
    download_all: 'Download all',
    filter_counts: 'Show Counts',
    filter_sites: 'Use My Sites',
    advanced_button: 'Advanced Search',
    reset_button: 'Clear All Filters',
    counts: 'Counts',
    data_export: 'Data Export',
    export_message:
      'This may take a few minutes.  We’ll email you the report once it’s finished.  Be sure to check your spam/junk folder.',
    description_placeholder: 'Enter Description',
    notes: 'Notes',
    notes_placeholder: 'Describe what you did on your service visit.',
    invoice_placeholder: 'Enter #',
    invoice: 'invoice',
    product_or_service: 'Product or service',
    summary: 'Summary',
    fill_message: 'Fill out your invoice and submit for approval',
    paid_message: 'Paid ',
    paid_by_message: 'by {type}',
    paid_on_message: 'on {date}',
    declined_message:
      'Please adjust your invoice and resubmit. Declined details can be found in the audit trail.',
    submitted_message: 'Thank you!  Your invoice will be reviewed soon!',
    invoice_number: 'Invoice',
    internal_invoice_number: 'Invoice #',
    invoice_number_error: 'Must be at least 3 characters',
    wo_number: 'WO #',
    wo_multiple: 'WO # Multiple',
    wo_completed: 'Work completed',
    bill_to: 'Bill to',
    nte: 'Not To Exceed',
    nte_message:
      'The total amount exceeds the NTE.  Adjust your total to be lower than the NTE or contact your representative to have the NTE adjusted.',
    nte_message_2: 'The total amount exceeds the NTE',
    nte_exceed_title: 'Exceed NTE Value',
    nte_exceed_message:
      'The total amount exceeds the NTE value. Do you want to continue?',
    service_notes_title: 'Service Notes',
    date_format: 'MM/DD/yyyy',
    date_ranges: {
      today: 'Today',
      yesterday: 'Yesterday',
      this_month: 'This Month',
      last_month: 'Last Month',
      last_two_months: 'Last Two Months',
      last_three_months: 'Last Three Months',
      last_six_months: 'Last Six Months'
    },
    in_actions: {
      create: 'Create',
      submit: 'Submit',
      add_item: 'Add item',
      add_labor: 'Add labor item',
      add_travel: 'Add travel item',
      add_material: 'Add material item',
      add_freight: 'Add freight item',
      add_other: 'Add other item'
    },
    action_messages: {
      draft_saved: 'Draft saved',
      invoice_submitted: 'Invoice sent succesfully',
      invoice_submit_error: 'The invoice was not submitted',
      pending_approval: 'Pending Client Approval'
    },
    in_states: {
      open: 'Open',
      declined: 'Declined',
      sent: 'Sent',
      approved: 'Approved',
      draft: 'Draft',
      drafts: 'Drafts',
      not_submitted: 'Not Submitted',
      no_status: 'No Status',
      total_open: 'Total open invoices',
      total_paid: 'Total paid invoices (USD)',
      total_submitted: 'Total submitted invoices',
      submitted: 'Submitted',
      work_complete: 'Work complete',
      not_available: 'Not Available',
      receipt: 'Receipt',
      paid: 'Paid',
      hold: 'Hold',
      voided: 'Voided'
    },
    audit_actions: {
      create: 'Invoice generated from completed work',
      edit: 'Edited',
      submit: 'Submitted',
      decline: 'Declined',
      approve: 'Approved',
      auto_create: 'Receipt auto-generated from months end activity',
      auto_approve: 'Receipt auto-approved based on completed work',
      paid: 'Paid',
      hold: 'Hold',
      voided: 'Voided'
    },
    column_names: {
      client_name: 'Client Name',
      client_location: 'Client Location',
      invoice: 'Invoice #',
      won: 'Work Order #',
      amount: 'Amount $',
      createDate: 'Created Date',
      dueDate: 'Due Date',
      inStatus: 'Status',
      terms: 'Terms',
      payment_type: 'Payment Type',
      total_amount: 'Total Amount',
      num: '#',
      item: 'Item',
      description: 'Description',
      trade: 'Trade',
      type: 'Type',
      rate: 'Rate',
      tax: 'Tax',
      qty: 'Qty',
      item_amount: 'Amount',
      product_family: 'Product Family',
      task: 'Task',
      date_sent: 'Date',
      scheduled_services_amount: 'Scheduled Services Amount',
      percentage_paid: '% Paid',
      amount_paid: 'Amount Paid',
      balance_due: 'Balance Due',
      payDate: 'Pay Date',
      achCheckNumber: 'ACH/Check #',
      submitDate: 'Submit Date'
    },
    items: {
      labor: 'Labor',
      travel: 'Travel',
      material: 'Material',
      freight: 'Freight',
      other: 'Other',
      discount: 'Discount',
      management: 'Management Fee',
      markup: 'Markup',
      overhead: 'Overhead & Profit',
      rental: 'Rental Fee',
      shipping: 'Shipping & Handling',
      scheduled: 'Scheduled Services',
      advance_payment: 'Advance Payment',
      refrigerant: 'Refrigerant'
    },
    toggle_labels: {
      all: 'All',
      custom: 'Custom',
      not_selected: 'Not Selected',
      select_all: 'Select All'
    },
    select_one: 'Select',
    apply_advanced: 'Apply Search',
    activities: 'Activities',
    audit: 'Audit Trail',
    details: 'Details',
    due: 'Due',
    empty_message_title: 'Whoops..',
    empty_message:
      'There are no invoices in your account. Contact your Management company to get new work!',
    empty_message_filters:
      'Your search did not return any results. Check your search criteria and try again.',
    please: 'Please',
    try: 'try again',
    clear_search: 'Clear Search',
    sort: 'Sort',
    clear: 'Clear',
    highest: 'Highest',
    lowest: 'Lowest',
    oldest: 'Oldest',
    newest: 'Newest',
    attach: 'Attach your invoice',
    add: 'Add',
    attach_error: 'Max. 3 Files',
    pop_up_warning:
      'Hide this pop-up but I understand these terms will apply to all futures invoices.',
    messages: {
      max_records:
        'Warning: Report generation is limited to a maximum of 5,000 records. Please reduce the number of selected records.',
      leave_title: 'Warning',
      leave_title2: 'Your changes have not been saved and will be lost if you leave this page.',
      leave_secondary: 'Are you sure you want to leave this page?'
    },
    refrigerant_item: {
      type: 'Refrigerant Type',
      service: 'Service',
      weight: 'Total Weight'
    },
    related_questions: 'Invoice related questions?',
    chat: 'Chat'
  }
}
